import { Button, Modal } from '@p2p/components';

import styles from './PaidConfirmModal.module.scss';

type PaidConfirmModalProps = {
  open: boolean;
  onSuccess: () => void;
  onClose: () => void;
};

export const PaidConfirmModal = ({ open, onSuccess, onClose }: PaidConfirmModalProps) => {
  return (
    <Modal open={open} onClose={onClose}>
      <h2 className={styles.modalTitle}>У вас получилось оплатить?</h2>
      <div className={styles.modalActions}>
        <Button onClick={onSuccess}>Да</Button>
        <Button variant="outlined" onClick={onClose}>
          Нет
        </Button>
      </div>
    </Modal>
  );
};
